// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__SoYwF","modal":"Modal_modal__tGRs2","slide-down":"Modal_slide-down__KBy75"};